import React from "react";
import { useTranslation } from "react-i18next";


export interface TimelineSegment {
    startSeconds: number;
    endSeconds: number;
    label?: string;
}

interface TimelineProps {
    segments: TimelineSegment[];
    timelineStart: number;// start time in seconds (e.g., 0 for midnight)
    timelineEnd: number; // end time in seconds (e.g., 86400 for 24h)
    onSeek: (segment: TimelineSegment) => void;
}

export const Timeline: React.FC<TimelineProps> = ({
    segments,
    timelineStart,
    timelineEnd,
    onSeek,
}) => {
    const totalSeconds = timelineEnd - timelineStart;
    const { t } = useTranslation();

    const hours = Array.from({ length: 24 }, (_, i) => i);

    return (
        <div
            className="timeline-container"
            style={{
                position: "relative",
                height: "40px",
                width: "100%",
                background: "#f7f1f1",
                color: "#ccc"
            }}
        >

            {/* Recording blocks */}
            {segments.map((seg, idx) => {
                const leftPercent = Math.round(((seg.startSeconds - timelineStart) / totalSeconds) * 10000) / 100;
                // Note: Add one second to endseconds to avoid tiny white gaps in timeline
                const rightPercent = Math.round(((timelineEnd - seg.endSeconds-1) / totalSeconds) * 10000) / 100;
                const startTime = secondsToHHMM(seg.startSeconds - timelineStart);
                return (
                    <div
                        key={idx}
                        onClick={() => onSeek(seg)}
                        style={{
                            position: "absolute",
                            left: `${leftPercent}%`,
                            right: `${rightPercent}%`,
                            height: "100%",
                            background: "rgba(90,138,177)",
                            cursor: "pointer",
                            zIndex: 1
                        }}
                        title={seg.label ?? t("timeline.recordingStartTimeFormat", { startTime: startTime })}
                    />
                );
            })}
            {/* Hour markers */}
            {hours.map((hour) => {
                const left = ((hour * 3600 - timelineStart) / totalSeconds) * 100;
                return (
                    <div
                        key={hour}
                        style={{
                            position: "absolute",
                            left: `${left}%`,
                            top: 0,
                            height: "100%",
                            borderLeft: "1px solid #555",
                            fontSize: "10px",
                            paddingLeft: "2px",
                            background: "transparent",
                            color: "black",
                            zIndex: 10,
                            pointerEvents: "none"
                        }}
                    >
                        {hour}:00
                    </div>
                );
            })}

        </div>
    );
};

function secondsToHHMM(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const pad = (n: number) => n.toString().padStart(2, "0");
    return `${pad(hours)}:${pad(minutes)}`;
}